import { useMutation } from '@tanstack/react-query';

import services from '@/services';
import type { DetachNewEntries } from '@/services/surveyService';

export const useDetachNewEntriesMutation = () => {
   return useMutation({
      mutationFn: async ({ surveyId, userId }: DetachNewEntries) => {
         return await services.survey.detachNewEntriesBySurveyId({
            surveyId,
            userId,
         });
      },
   });
};
